// @ts-nocheck

import useResizeObserver from 'hooks/useResizeObserver';
import { useEffect, useMemo } from 'react';

const COLLAPSE_HEADER_HEIGHT = 54;
const DRAWER_BODY_SELECTOR = '.top-menu-drawer .ant-drawer-body';

const useDrawerHeight = (filterDrawerOpen, collapseItemCount) => {
  const [setNode, entry] = useResizeObserver();

  useEffect(() => {
    if (!filterDrawerOpen) return () => {};

    // Drawer renders via portal — the body element may not exist yet.
    // Use MutationObserver to reliably detect when it appears in the DOM.
    const element = document.querySelector(DRAWER_BODY_SELECTOR);
    if (element) {
      setNode(element);
      return () => {};
    }

    const observer = new MutationObserver(() => {
      const found = document.querySelector(DRAWER_BODY_SELECTOR);
      if (found) {
        setNode(found);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [filterDrawerOpen, setNode]);

  const height = useMemo(() => {
    const currentHeight = entry?.contentRect?.height;

    if (currentHeight > 0 && collapseItemCount > 0) {
      return Math.max(0, currentHeight - (COLLAPSE_HEADER_HEIGHT * collapseItemCount));
    }

    return 0;
  }, [entry, collapseItemCount]);

  return height;
};

export default useDrawerHeight;
